export default __webpack_public_path__ + "static/media/innovation.048d06f1.svg";